<script lang="ts">
	import amexSvg from './svg/AmericanExpress.svg';
	import applePaySvg from './svg/ApplePay.svg';
	import googlePaySvg from './svg/GooglePay.svg';
	import klarnaRechnungSvg from './svg/KlarnaRechnung.svg';
	import klarnaSofortSvg from './svg/KlarnaSofort.svg';
	import maestroSvg from './svg/Maestro.svg';
	import masterCardSvg from './svg/MasterCard.svg';
	import payPalSvg from './svg/PayPal.svg';
	import visaSvg from './svg/Visa.svg';
	import idealSvg from './svg/Ideal.svg';
	import { _ } from 'svelte-i18n';

	const width = 300;
	const height = 100;
</script>

<section aria-label={$_('components.footer.paymentProviderList.title')}>
	<ul>
		<li>
			<img src={payPalSvg} alt="PayPal" loading="lazy" {width} {height} />
		</li>
		<li>
			<img src={applePaySvg} alt="Apple Pay" loading="lazy" {width} {height} />
		</li>
		<li>
			<img src={googlePaySvg} alt="Google Pay" loading="lazy" {width} {height} />
		</li>
		<li>
			<img src={klarnaSofortSvg} alt="Klarna Sofort" loading="lazy" {width} {height} />
		</li>
		<li>
			<img src={klarnaRechnungSvg} alt="Klarna Rechnung" loading="lazy" {width} {height} />
		</li>
		<li>
			<img src={visaSvg} alt="VISA" loading="lazy" {width} {height} />
		</li>
		<li>
			<img src={masterCardSvg} alt="MasterCard" loading="lazy" {width} {height} />
		</li>
		<li>
			<img src={amexSvg} alt="American Express" loading="lazy" {width} {height} />
		</li>
		<li>
			<img src={maestroSvg} alt="Maestro" loading="lazy" {width} {height} />
		</li>
		<li>
			<img src={idealSvg} alt="iDEAL" loading="lazy" {width} {height} />
		</li>
	</ul>
</section>

<style>
	section {
		border-top: 1px solid hsla(0, 0%, 93%, 50%);
		border-bottom: 1px solid hsla(0, 0%, 93%, 50%);
		padding: 2rem;
	}

	ul {
		display: flex;
		justify-content: space-evenly;
		flex-wrap: wrap;
		gap: 1rem;

		list-style: none;
		margin: 0;
		padding: 0;
	}

	li {
		margin: 0;
		padding: 0;
	}

	img {
		height: 1.8rem;
		width: auto;
	}
</style>
